import React, { useEffect, useState } from 'react';
import { Select, TextField, Button, MenuItem, CircularProgress } from '@mui/material';
import * as themeService from "../../../services/ThemeService";
import * as tenyZarainaService from "../../../services/TenyZarainaService";
import logo from '../../../assets/imgs/logo1.png';
import { useNavigate, useParams } from 'react-router-dom';
import './edit.scss';
import { transformDate } from '../../../utils/date.formate';
import { baseUrl } from '../../../config/config';
import BackButton from './../../../components/BackButton/BackButton';
import Swal from 'sweetalert2';

const UpdateTenyZaraina = () => {
  const { id } = useParams(); 

  const [title, setTitle] = useState('');
  const [contenu, setContenu] = useState('');
  const [vavaka, setVavaka] = useState('');
  const [file, setFile] = useState(null);
  const [theme, setTheme] = useState([]);
  const [options, setOptions] = useState(null);
  const [audio, setAudio] = useState(null);
  const [createdAt, setCreatedAt] = useState('');

  const navigate = useNavigate();

  const [videoUrl, setVideoURL] = useState(null);
  const [audioUrl, setAudioURL] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Récupérer les données actuelles du TenyZaraina en fonction de son ID
    tenyZarainaService.getTenyZarainaById(id)
      .then((tenyzaraina) => {
        setTitle(tenyzaraina.title);
        setContenu(tenyzaraina.contenu);
        setVavaka(tenyzaraina.vavaka);
        setFile(tenyzaraina.file);
        setAudio(tenyzaraina.audio);
        setCreatedAt(tenyzaraina.createdAt)
        setOptions(tenyzaraina.theme || null);
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération du TenyZaraina:", error);
      });

    // Récupérer la liste des thèmes
    themeService.getAllTheme()
      .then((themes) => {
        setTheme(themes);
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des thèmes:", error);
      });
  }, [id]);

  async function handleSubmit(e) {
    e.preventDefault();
    
    setIsLoading(true);
    let them = theme.find(e => e.id === options?.id);
    const formData = new FormData();
    formData.append('title', title);
    formData.append('contenu', contenu);
    formData.append('vavaka', vavaka);
    formData.append('file', file);
    formData.append('themeId', them ? them.id : null);
    formData.append('createdAt', createdAt);
  
    // Ajouter l'audio uniquement s'il a été sélectionné
    if (audio) {
      formData.append('audio', audio);
    }
  
     // console.log({
    //   title,
    //   contenu,
    //   vavaka,
    //   file,
    //   audio,
    //   createdAt,
    //   them
    // })
    
    try {
      const res = await tenyZarainaService.updateTenyZarainaById(id, formData);
      if (res && res.status === 200) {
        Swal.fire(
          'Teny zaraina mis à jour !',
          'Mise à jour réussie',
          'success'
        ).then(() => {
          navigate(`/tenyzaraina`);
        });
      } else {
        Swal.fire(
          'Erreur',
          'Une erreur s\'est produite',
          'error'
        );
      }
    } catch (err) {
      console.error('Erreur lors de la mise à jour du TenyZaraina :', err);
      Swal.fire(
        'Erreur',
        'Une erreur s\'est produite',
        'error'
      );
    } finally {
      setIsLoading(false);
    }
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFile(file)
    if (file) {
      console.log(file)
      const objectURL = URL.createObjectURL(file);
      setVideoURL(objectURL);
    }
  };

  const handleAudioChange = (e) => {
    const newAudioFile = e.target.files[0];
    setAudio(newAudioFile);
    // Révoquer l'URL d'objet précédent
    if (audioUrl !== null) {
      URL.revokeObjectURL(audioUrl);
    }
    // Créer une nouvelle URL d'objet pour le nouvel audio
    const newAudioURL = newAudioFile ? URL.createObjectURL(newAudioFile) : null;
    // Mettre à jour l'état
    setAudioURL(newAudioURL);
  };

  return (
    <div className="updateTeny">
      <div className="back" >
        <BackButton />
      </div>

      <div className="contain-teny">
        <div className="formTeny">
          <form onSubmit={handleSubmit} >
            <p className='titre'>modification teny zaraina</p>
            <div className="tenyZ">
              <label className='label-tenyZ' >Date de publication</label>
              <TextField 
                label="Date"
                variant="outlined"
                type="date"
                value={createdAt}
                onChange={(e) => setCreatedAt(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div className="tenyZ">
              <label className='label-tenyZ' >Lohateny</label>
              <TextField 
                label="Lohateny"
                variant="outlined"
                multiline
                maxRows={1000}
                type='text'
                value={title}
                onChange={(e)=> setTitle(e.target.value)}
              />
            </div>
            <div className="tenyZ">
              <label className='label-tenyZ' >Famakafakana</label>
              <TextField 
                label="Contenu"
                variant="outlined"
                multiline
                maxRows={1000}
                type='text'
                value={contenu}
                onChange={(e)=> setContenu(e.target.value)}
              />
            </div>
            <div className="tenyZ">
              <label className='label-tenyZ'>Vavaka</label>
              <TextField 
                label="Vavaka"
                variant="outlined"
                multiline
                maxRows={1000}
                type='text'
                value={vavaka}
                onChange={(e)=>setVavaka (e.target.value)}
              />
            </div>
            {theme && (
              <div className="selection-theme">
                <label className='label-tenyZ'>Loha-hevitra</label>
                <Select
                  value={options || null} // Utilisation de l'option vide si options est null
                  onChange={(e) => setOptions(e.target.value)}
                  label="Loha-hevitra"
                >
                  <MenuItem value="">Aucun thème</MenuItem>
                  {theme.map((themes) => (
                    <MenuItem key={themes.id} value={themes}>{themes.nomTheme}</MenuItem>
                  ))}
                </Select>
              </div>
            )}
            <div className="dowload">
              <Button component="label" variant="contained" margin='normal' style={{background:'#bf9e1d', margin: '10px 15px',padding: '10px 25px'}}>
                modifier la photo ou vidéo
                <input hidden 
                  type="file" 
                  onChange={handleFileChange} 
                  accept="image/png, image/jpeg, video/mp4, image/jpg, image/PNG, image/gif"
                  />
              </Button>
              <Button component="label" variant="contained" margin='normal' style={{background:'#bf9e1d', margin: '10px 15px',padding: '10px 25px'}}>
                modifier l'audio
                <input hidden 
                  type="file" 
                  onChange={handleAudioChange} 
                  accept="audio/mp3"
                  />
              </Button>
            </div>
            <Button variant="contained" type='submit' margin='normal' disabled={isLoading} style={{background:'#2b2b81', marginTop:'10px'}}>
              {isLoading ? <CircularProgress size={24}/> : "Modifier"}
            </Button>
          </form>
        </div>
      
        <div className="apercu-teny">
          <div className="entete">
            <img src={logo} alt="logo" />
            <div className="date">
              <span className="title">Teny Zaraina</span>
              <span className="date-publication">{transformDate(createdAt)}</span>
            </div>
          </div>
          <div className="teny">
            <p>{title}</p>
            <p>{contenu}</p>
            {vavaka ? <p><strong>VAVAKA:</strong> {vavaka}</p> : null}
            {file !== null && 
              <div>
                {typeof(file) === "string" ? (
                  !file.endsWith('.mp4') ? 
                  <img src={`${baseUrl}/${file}`} alt="Preview" />
                  :
                  <video width="500" height="500" autoPlay controls>
                    <source src={`${baseUrl}/${file}`} type="video/mp4" />
                  </video>
                ) : 
                file.name.endsWith('.mp4') ? 
                <video width="500" height="500" autoPlay controls>
                  <source src={videoUrl} type="video/mp4" />
                </video>:
                <img src={videoUrl} alt="Preview" />
                }
              </div>
            }
            <div className="audio-container">
              {audio && (
                <audio className="image-preview" controls>
                  <source src={`${baseUrl}/${audio}`} type='audio/mp3' />
                </audio>
              )}
              {!audio && audioUrl && (
                <audio className="image-preview" controls>
                  <source src={audioUrl} type='audio/mp3' />
                </audio>
              )}
            </div>
          </div>
          {options && <div>
            <p style={{fontSize: "18px"}}><strong>LOHAHEVITRA:</strong> {options.nomTheme}</p>
          </div>}
        </div>
      </div>
    </div>
  )
}

export default UpdateTenyZaraina;